module.exports = __webpack_public_path__ + "img/arrow_end.84cd0581.svg";